import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectPath = sessionStorage.getItem("redirect_after_login") || "/";

    sessionStorage.removeItem("redirect_after_login");

    navigate(redirectPath, { replace: true });
  }, [navigate]);

  return (
    <div className="w-full h-screen flex items-center justify-center">
      <div className="flex items-center gap-2 text-gray-600">
        <div className="animate-spin border-2 border-gray-300 border-t-primary rounded-full w-4 h-4"></div>
        Redirecting...
      </div>
    </div>
  );

}
